module.exports = __webpack_public_path__ + "static/media/leisure_hover.f9864575.jpg";